import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { AppState } from "..";

export interface HelmetState {
  commonTitle: string;
  ignoreCommonTitle: boolean;
  title: string;
  meta?: {
    title: string;
    description: string;
    keywords: string;
  } | null;
  metaModifiedTime?: string;
  og?: {
    type: string;
    url: string;
    title: string;
    description: string;
    image: string;
  } | null;
  schemas?: string[];
  path?: string;
  canonical?: string;
}

const initialState: HelmetState = {
  commonTitle: "Senco Gold & Diamonds",
  ignoreCommonTitle: false,
  title: "",
};

export const helmetSlice = createSlice({
  name: "helmet",
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<HelmetState["title"]>) => {
      state.title = action.payload;
      state.ignoreCommonTitle = false;
    },
    setMeta: (state, action: PayloadAction<HelmetState["meta"]>) => {
      state.meta = action.payload;
    },
    setMetaModifiedTime: (
      state,
      action: PayloadAction<HelmetState["metaModifiedTime"]>
    ) => {
      state.metaModifiedTime = action.payload;
    },
    setOg: (state, action: PayloadAction<HelmetState["og"]>) => {
      state.og = action.payload;
    },
    setSchemas: (state, action: PayloadAction<HelmetState["schemas"]>) => {
      state.schemas = action.payload;
    },
    setPath: (state, action: PayloadAction<HelmetState["path"]>) => {
      state.path = action.payload;
      delete state.canonical;
    },
    setCanonical: (state, action: PayloadAction<HelmetState["canonical"]>) => {
      if (action.payload) {
        state.canonical = action.payload;
      } else {
        delete state.canonical;
      }
    },
    setIgnoreCommonTitle: (
      state,
      action: PayloadAction<HelmetState["ignoreCommonTitle"]>
    ) => {
      state.ignoreCommonTitle = action.payload;
    },
  },

  extraReducers: {
    [HYDRATE]: (state, action) => {
      if (action.payload.helmet.title) {
        state.title = action.payload.helmet.title;
      }
      if (action.payload.helmet.commonTitle) {
        state.commonTitle = action.payload.helmet.commonTitle;
      }
      if (action.payload.helmet.meta) {
        state.meta = action.payload.helmet.meta;
      }
      if (action.payload.helmet.metaModifiedTime) {
        state.metaModifiedTime = action.payload.helmet.metaModifiedTime;
      }
      if (action.payload.helmet.og) {
        state.og = action.payload.helmet.og;
      }
      if (action.payload.helmet.schemas) {
        state.schemas = action.payload.helmet.schemas;
      }
      state.path = action.payload.helmet.path;
      if (action.payload.helmet.canonical) {
        state.canonical = action.payload.helmet.canonical;
      } else {
        delete state.canonical;
      }
      state.ignoreCommonTitle = action.payload.helmet.ignoreCommonTitle;
    },
  },
});

export const {
  setTitle,
  setMeta,
  setOg,
  setMetaModifiedTime,
  setIgnoreCommonTitle,
  setSchemas,
  setPath,
  setCanonical,
} = helmetSlice.actions;

export const selectHelmet = (state: AppState) => state.helmet;

export default helmetSlice.reducer;
